import http from "@/utils/http";


export const SysCommonlyMenuApi = {
	getCurrUserMenu(){
		return http.get(`/server/sysCommonlyMenu/getCurrUserMenu`);
	},
	deleteById(menuId){
		return http.get(`/server/sysCommonlyMenu/deleteById/${menuId}`);
	},
	insert(param){
		return http.post(`/server/sysCommonlyMenu/insert`,param);
	},

}